import { buildMatchPath } from "pages/PageConfigs";
import { MatchContainer, MatchTitle } from "./styles";
import { ShuffleBracketNode } from "model/Bracket/ShuffleBracketGraph";
import { ShuffleBracketMatchTeam } from "./ShuffleBracketMatchTeam";
import { Match } from "model/Match/Match";
import { PlainNavLink } from "styles/elements";

interface Props {
  node: ShuffleBracketNode;
  match: Match;
  tournamentId: string;
}

export const ShuffleBracketMatch = ({ node, match, tournamentId }: Props) => {
  return (
    <PlainNavLink to={buildMatchPath(match.id)}>
      <MatchContainer>
        <MatchTitle>{node.matchTitle}</MatchTitle>
        {node.teamSources.map((s, i) => (
          <ShuffleBracketMatchTeam
            match={match}
            roster={match.teams.rosters.at(i)}
            tournamentId={tournamentId}
            source={s}
          />
        ))}
      </MatchContainer>
    </PlainNavLink>
  );
};
